import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { PLAYLIST_CONTENT_NAVIGATION_URL_FRAGMENTS, TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT, TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT, TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT } from '../../../constants/Navigation';
import { getLessonBaseUrl, getTrackBaseUrl } from '../../../utils/RoutingUtils';
import { usePlaylist } from '../../savedItems';
import { usePlaylistProgress } from '../../userProgress';
import { usePlaylistIdFromSearch } from '../hooks';
import getLang from 'LearningCenterUI/utils/getLang';
import useNavigate from '../../../hooks/useNavigate';
import { getShortContentUrl } from '../../shortContent';
import { jsx as _jsx } from "react/jsx-runtime";
const useRenderParams = ({
  contentType,
  trackId,
  lessonId,
  shortId,
  nextPlaylistItem,
  playlistProgress,
  redirectUrl,
  language
}) => {
  const navigate = useNavigate();
  const urlBuilder = suffix => {
    if (contentType === 'TRACK' && trackId) {
      return getTrackBaseUrl(trackId.toString(), suffix);
    } else if (contentType === 'LESSON' && lessonId) {
      return getLessonBaseUrl(lessonId.toString(), suffix);
    } else if (contentType === 'SHORT_FORM_CONTENT' && shortId && language) {
      return `${getShortContentUrl({
        shortId,
        language
      }).fullUrl}/${suffix}`;
    }
    return '';
  };
  const renderParams = {
    urlFragments: PLAYLIST_CONTENT_NAVIGATION_URL_FRAGMENTS,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistContent.nextPlaylistContent.incompleteTitle"
    }),
    subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistContent.nextPlaylistContent.incompleteSubtitle"
    }),
    url: urlBuilder(TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT),
    language: language || getLang(),
    navigate: () => {}
  };
  if (playlistProgress && playlistProgress.status === 'COMPLETED') {
    renderParams.title = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistContent.nextPlaylistContent.completeTitle"
    });
    renderParams.url = urlBuilder(TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT);
  } else if (nextPlaylistItem) {
    const {
      itemId,
      type,
      language: itemLanguage,
      name
    } = nextPlaylistItem;
    renderParams.trackId = type === 'TRACK' ? itemId : undefined;
    renderParams.lessonId = type === 'LESSON' ? itemId : undefined;
    renderParams.shortId = type === 'SHORT_FORM_CONTENT' ? itemId : undefined;
    renderParams.subtitle = name;
    renderParams.language = itemLanguage;
    if (type === 'SHORT_FORM_CONTENT') {
      // open short directly instead of rendering a short inside a short
      renderParams.url = getShortContentUrl({
        shortId: itemId,
        language: itemLanguage
      }).fullUrl;
    } else {
      renderParams.url = urlBuilder(TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT);
    }
  }
  if (redirectUrl && !redirectUrl.includes('recommendations')) {
    renderParams.url = redirectUrl;
  }
  const navigateToLastSection = useCallback(() => {
    navigate(location => Object.assign({}, location, {
      pathname: renderParams.url || ''
    }));
  }, [navigate, renderParams.url]);
  renderParams.navigate = navigateToLastSection;
  return renderParams;
};
export const NextPlaylistContent = ({
  trackId,
  lessonId,
  shortId,
  render,
  redirectUrl,
  language
}) => {
  const playlistId = usePlaylistIdFromSearch();
  const {
    playlist
  } = usePlaylist(playlistId, !playlistId);
  const {
    playlistProgress
  } = usePlaylistProgress(playlistId);
  const contentType = shortId ? 'SHORT_FORM_CONTENT' : trackId ? 'TRACK' : 'LESSON';
  const nextPlaylistItemIndex = playlist ? playlist.items.findIndex(item => item.itemId === (trackId || lessonId || shortId) && item.type === contentType && (!language || item.language === language)) + 1 : -1;
  const nextPlaylistItem = playlist && playlist.items[nextPlaylistItemIndex];
  const renderParams = useRenderParams({
    contentType,
    trackId,
    lessonId,
    shortId,
    nextPlaylistItem,
    playlistProgress,
    redirectUrl,
    language
  });
  return render(renderParams);
};